import React from "react";
import Speedometer, {
	Background,
	Arc,
	Needle,
	Progress,
	Marks,
	Indicator,
	DangerPath,
} from "react-speedometer";
import { useSelector } from "react-redux";

export default function OdooMeter({ speed }) {
	const inf = useSelector((state) => state.users.user);
	console.log("ODOMETERSpeed", speed);

	const SpeedUnit = (number, unit) => {
		const num = Number(number);
		if (isNaN(num)) return 0;
		if (unit === "kmh") {
			return Math.floor(num * 1.852);
		} else if (unit === "mph") {
			return (num * 1.15078).toFixed(0);
		} else {
			return num.toFixed(0);
		}
	};
	return (
		<div>
			{" "}
			<Speedometer
				value={`${SpeedUnit(speed, inf?.attributes?.speedUnit || "kn")}`}
				min={0}
				max={280}
				fontFamily="Roboto"
				width={120}
			>
				<Background opacity={1} color="#000" />
				<Arc color="#f48" />
				<Needle
					baseWidth={1}
					baseOffset={1}
					circleColor="#2E9245"
					circleRadius={8}
				/>
				<Progress color="#2E9245" />
				<DangerPath />
				<Marks
					fontSize={10}
					numbersRadius={8}
					lineOpacity={0.8}
					lineSize={9}
					lineCap="square"
				/>
				<Indicator fontSize={14} spreadMethod="true" />
			</Speedometer>
		</div>
	);
}
